import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Package } from './package'
import { PackageService } from './package.service'

@Injectable({ providedIn: 'root' })
export class PackageResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private router = inject(Router)
  private packageService = inject(PackageService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<Package> {
    const id = route.paramMap.get('id')

    return this.packageService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('Failed to load Package', err)
        this.router.navigate(['app/packages'])
        return EMPTY
      })
    )
  }
}
